
import { useLocation } from "react-router-dom";
import { NavigationLink } from "./NavigationLink";
import { mainLinks, toolLinks, profileLinks } from "./NavigationConfig";
import { LogoutButton } from "./LogoutButton";

export const DesktopNavigation = () => {
  const location = useLocation();
  
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="hidden md:block md:relative md:border-r md:w-64 md:h-screen">
      <div className="flex flex-col h-full p-4">
        <div className="flex-1 flex flex-col space-y-1">
          {mainLinks.map((link) => (
            <NavigationLink
              key={link.path}
              {...link}
              isActive={isActive(link.path)}
              className="p-3 rounded-lg"
            />
          ))}
          
          <div className="mt-4 mb-2">
            <div className="flex items-center px-3 py-2">
              <span className="hidden md:inline text-xs font-medium text-gray-500 uppercase tracking-wider">Herramientas</span>
            </div>
            
            {toolLinks.map((link) => (
              <NavigationLink
                key={link.path}
                {...link}
                isActive={isActive(link.path)}
                className="p-3 rounded-lg"
              />
            ))}
          </div>
          
          {profileLinks.map((link) => (
            <NavigationLink
              key={link.path}
              {...link}
              isActive={isActive(link.path)}
              className="p-3 rounded-lg"
            />
          ))}
        </div>
        
        <LogoutButton className="flex items-center p-3 rounded-lg mt-auto" />
      </div>
    </nav>
  );
};
